module.exports = __webpack_public_path__ + "img/Solvay_120X35.ee2289fc.png";